import { AnyRoute, createRoute } from '@tanstack/react-router'

import ReleaseNotes from './ReleaseNotes'

export const routeReleaseNotesRoute = <T extends AnyRoute>(rootRoute: T) =>
  createRoute({
    getParentRoute: () => rootRoute,
    path: '/release-notes',
    component: ReleaseNotes
  })
